import * as React from 'react';
import PropTypes from 'prop-types';

import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';

import MenuItem from '@mui/material/MenuItem';

import { DataGrid } from '@mui/x-data-grid';

import { getPayers } from '../../../../services/api/apiManager';

import { useState, useEffect } from 'react';

import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';

import Tooltip from '@mui/material/Tooltip';

import IconButton from '@mui/material/IconButton';

import DialogTitle from '@mui/material/DialogTitle';

import Dialog from '@mui/material/Dialog';

import DialogContent from '@mui/material/DialogContent';

import { useTheme } from '@mui/material/styles';

import { updatePayer } from '../../../../services/api/apiManager';

import CancelIcon from '@mui/icons-material/Cancel';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import * as Yup from 'yup';

import {
	Alert,
	Box,
	Button,
	Grid,
	Input,
	InputLabel,
	Modal,
	Snackbar,
	Typography,
	useMediaQuery,
	TextField,
	InputAdornment,
	Select,
} from '@mui/material';
import BrandedLoader from '../../../../components/BrandedLoader/BrandedLoader';
import {
	Add,
	ApartmentOutlined,
	BusinessOutlined,
	Call,
	CreditCardOutlined,
	FilterList,
	FormatListBulletedOutlined,
	Inventory2Outlined,
	PersonOutline,
	PlaceOutlined,
	Search,
} from '@mui/icons-material';
import MaskedInput from 'react-text-mask';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 'min(820px, calc(100vw - 32px))',
	backgroundColor: 'white',
	border: '1px solid #dce8f5',
	borderRadius: '10px',
	boxShadow: '0 18px 45px rgba(15, 23, 42, 0.18)',
	outline: 'none',
};

function Viewpayer({ renderHandleFromChild, openAddPayerModal }) {
	// Edit Delete Popover states and functions are here
	const [anchorED, setAnchorED] = React.useState(null);
	const editDelete_pop_opens = Boolean(anchorED);
	const handleClick = (event, params) => {
		// i am opening my popover from here and also setting values of modals from here am setting delete and edit modal states data from here

		setModalValues(params?.row);

		//setting deleteModal Data
		setDeleteUser(params?.row?.Name);
		setDeleteID(params?.row?.id);

		setAnchorED(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorED(null);
	};

	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const [payers, setPayers] = useState([]);
	const [searchText, setSearchText] = useState('');
	const [typeFilter, setTypeFilter] = useState('');

	const [openModal, setOpenModal] = useState(false);

	// Delete Data States
	const [deleteID, setDeleteID] = useState();
	const [deleteUser, setDeleteUser] = useState();
	// Loader State
	const [loading, setLoading] = useState(false);
	// Dialog State
	const theme = useTheme();
	const [dialogOpen, setDialogOpen] = React.useState(false);
	const [deletePopupOpen, setDeletePopupOpen] = React.useState(false);
	const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

	// Function -- Edit Payer
	const [modalValues, setModalValues] = useState([]);

	// Close Modal
	const handleCloseModal = () => {
		setOpenModal(false);
	};

	const schema = Yup.object().shape({
		Name: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		// City: Yup.string().matches(/^[a-zA-Z\s]+$/, 'Alphabets only'),
		// State: Yup.string().matches(/^[a-zA-Z]+$/, 'Alphabets only'),
		// Contact: Yup.string().matches(
		// 	/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
		// 	'Invalid '
		// ),
		// Zip: Yup.string().matches(
		// 	/^\+?1?\(?\d{3}\)?[-\s]*\d{2}[-\s]*\d{4}$|^\+?\d+$/,
		// 	'Invalid '
		// ),
	});

	const [errors, setErrors] = useState({});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setModalValues((prev) => ({
			...prev,
			[name]: value,
		}));
		if (name === 'Name') {
			Yup.reach(schema, name)
				.validate(value)
				.then(() => {
					setErrors((prevErrors) => ({
						...prevErrors,
						[name]: '', // Clear error if validation passes
					}));
				})
				.catch((error) => {
					setErrors((prevErrors) => ({
						...prevErrors,
						[name]: error.message, // Set error message if validation fails
					}));
				});
		}
	};

	// Snackbar States
	const [severity, setSeverity] = useState('success'); // Default severity
	const [openSnackbar, setOpenSnackbar] = useState(false);
	// open snakbar
	const handleClickSnackbar = () => {
		setOpenSnackbar(true);
	};
	//   close Snackbar
	const handleCloseSnackbar = () => {
		setOpenSnackbar(false);
	};

	// Fetch Api Payer Data
	const fetchPayers = async () => {
		setLoading(true);
		try {
			const response = await getPayers();

			if (response?.status === 200) {
				setLoading(false);
				setPayers(response?.data?.reverse());
			} else {
				setPayers([]);
			}
		} catch (error) {
			console.error('Error fetching payers:', error);
		}
	};

	// Calling API Data
	useEffect(() => {
		fetchPayers();
	}, []);

	// Function -- Target Modal Textfields Values
	const targetModalValue = (event) => {
		event.preventDefault();
		setModalValues({
			...modalValues,
			[event.target.name]: event.target.value,
		});
	};

	// // Function -- Edit Payer Data
	const handleEdit = () => {
		// Close the action menu first, then open the modal
		setAnchorED(null);
		setOpenModal(true);
	};

	// Function -- Edit Payer Data
	// Function -- Update Payer Data
	const updateModalValues = async (modalValues) => {
		if (
			errors?.Name ||
			errors?.City ||
			errors?.Contact ||
			errors?.State ||
			errors?.Zip
		) {
		} else {
			setLoading(true);
			const resp = await updatePayer(modalValues.id, modalValues);
			setAnchorED(null);
			if (resp?.request?.status === 200) {
				// Update, Then Close Modal
				handleCloseModal();
				// Open Snackbar Alert
				handleClickSnackbar('success');
				setSeverity('updated');
				setLoading(false);
				fetchPayers();

				// // Snackbar Color Show
				// try {
				// 	const newData = await fetchPayers();
				// 	setLoading(false);
				// 	// console.log(newData);
				// } catch (error) {
				// 	console.error('Error fetching data:', error);
				// }
			}
		}
	};

	const handleDialogClose = () => {
		setDialogOpen(false);
	};

	const deleteCancelPopup = () => {
		setDeletePopupOpen(false);
	};

	const handleDialogOpen = () => {
		setDialogOpen(true);
	};

	// Function -- Set open Delete PopUp-Modal
	const handleDelete = () => {
		handleClose();
		setDeletePopupOpen(true);
	};

	// Handle Delete Status Data
	const deleteStatus = {
		Deleted: true,
	};

	// Function -- Delete Data
	const deletePayer = async (deleteID) => {
		const response = await updatePayer(deleteID, deleteStatus);
		setLoading(true);

		if (response?.request?.status === 200) {
			setSeverity('success');
			setDeletePopupOpen(false);
			setLoading(false);
			handleClickSnackbar('error');
			try {
				const newData = await fetchPayers();
				setLoading(false);
				// console.log(newData);
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		} else {
			setDeletePopupOpen(false);
			// setLoading(false);
		}
		setAnchorED(null);
	};

	// Data Grid Rows Data
	const rows =
		payers &&
		payers?.map((p, index) => ({
			// payerId: index,
			id: p?.id,
			Name: p?.Name || '',
			Type: p?.Type || '',
			Contact: p?.Contact || '',
			Address: p?.Address || '',
			Comments: p?.Comments || '',
			City: p?.City || '',
			State: p?.State || '',
			Zip: p?.Zip || '',
		}));

	const payerTypes = [...new Set(rows?.map((row) => row.Type).filter(Boolean))];

	const filteredRows = rows?.filter((row) => {
		const search = searchText.trim().toLowerCase();
		const matchesSearch =
			!search ||
			[row.Name, row.Type].some((value) =>
				(value || '').toLowerCase().includes(search)
			);
		const matchesType = !typeFilter || row.Type === typeFilter;
		return matchesSearch && matchesType;
	});

	const getTypeBadgeSx = (type) => {
		const normalizedType = (type || '').toLowerCase();
		const badgeMap = {
			hmo: { color: '#2563eb', backgroundColor: '#eaf2ff' },
			msc: { color: '#17865a', backgroundColor: '#e6f6ee' },
			other: { color: '#526072', backgroundColor: '#eef2f6' },
			medicaid: { color: '#6d3edb', backgroundColor: '#f0e9ff' },
			mgg: { color: '#d97706', backgroundColor: '#fff0de' },
		};
		const colors = badgeMap[normalizedType] || {
			color: '#2563eb',
			backgroundColor: '#eaf2ff',
		};

		return {
			...colors,
			borderRadius: '8px',
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
			minWidth: '44px',
			height: '24px',
			px: 1,
			fontFamily: 'Poppins',
			fontSize: '12px',
			fontWeight: 600,
			textTransform: 'uppercase',
		};
	};

	const renderTextCell = (params) => (
		<Typography
			component="span"
			sx={{
				color: params.value ? '#0b2450' : '#8b9ab0',
				fontFamily: 'Poppins',
				fontSize: '13px',
				fontWeight: 500,
				whiteSpace: 'nowrap',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
			}}
		>
			{params.value || '-'}
		</Typography>
	);

	const modalLabelSx = {
		fontFamily: 'Poppins',
		fontSize: '13px',
		fontWeight: 600,
		color: '#0b2450',
		mb: 0.8,
	};

	const modalFieldSx = {
		'& .MuiOutlinedInput-root': {
			height: '42px',
			borderRadius: '6px',
			fontFamily: 'Poppins',
			fontSize: '13px',
			color: '#0b2450',
			'& fieldset': { borderColor: '#d7e3f4' },
			'&:hover fieldset': { borderColor: '#b8c9df' },
			'&.Mui-focused fieldset': { borderColor: '#2f6edb' },
		},
		'& .MuiInputBase-input': {
			padding: '10px 14px',
		},
	};

	const modalMultilineFieldSx = {
		...modalFieldSx,
		'& .MuiOutlinedInput-root': {
			...modalFieldSx['& .MuiOutlinedInput-root'],
			height: '96px',
			alignItems: 'flex-start',
		},
		'& .MuiInputBase-input': {
			padding: '12px 14px',
		},
	};

	const modalMaskedInputStyle = {
		width: '100%',
		height: '42px',
		borderRadius: '6px',
		border: '1px solid #d7e3f4',
		padding: '10px 40px 10px 14px',
		outline: 'none',
		fontFamily: 'Poppins',
		fontSize: '13px',
		color: '#0b2450',
		boxSizing: 'border-box',
	};

	const modalSelectMenuProps = {
		PaperProps: {
			sx: {
				mt: 0.5,
				borderRadius: '6px',
				boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)',
				'& .MuiMenuItem-root': {
					fontFamily: 'Poppins',
					fontSize: '13px',
				},
			},
		},
	};

	const columns = [
		// { field: 'payerId', headerName: 'Index', width: 80 },
		// { field: 'id', headerName: 'Id', width: 80 },
		{
			field: 'Name',
			headerName: 'Name',
			flex: 1.2,
			minWidth: 220,
			renderCell: renderTextCell,
		},
		{
			field: 'Type',
			headerName: 'Type',
			flex: 0.6,
			minWidth: 120,
			renderCell: (params) =>
				params.value ? (
					<Box sx={getTypeBadgeSx(params.value)}>{params.value}</Box>
				) : (
					renderTextCell(params)
				),
		},
		{
			field: 'Contact',
			headerName: 'Contact',
			flex: 0.9,
			minWidth: 150,
			renderCell: renderTextCell,
		},
		{
			field: 'Address',
			headerName: 'Address',
			flex: 1.7,
			minWidth: 260,
			renderCell: renderTextCell,
		},
		{
			field: 'Comments',
			headerName: 'Comments',
			flex: 1.1,
			minWidth: 200,
			renderCell: renderTextCell,
		},
		// { field: 'City', headerName: 'City', width: 130, },
		// { field: 'State', headerName: 'State', width: 130, },
		// { field: 'Zip', headerName: 'Zip', width: 100, },
		{
			sortable: false,
			disableColumnMenu: true,
			field: 'action',
			headerName: 'Action',
			description: 'This column has a value getter and is not sortable.',
			sortable: false,

			flex: 0.4,
			minWidth: 100,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params) => {
				return (
					<div>
						<IconButton
							aria-label="more"
							id="long-button"
							aria-controls={editDelete_pop_opens ? 'long-menu' : undefined}
							aria-expanded={editDelete_pop_opens ? 'true' : undefined}
							aria-haspopup="true"
							onClick={(event) => {
								handleClick(event, params);
							}}
						>
							<MoreVertIcon />
						</IconButton>
						<Menu
							sx={{ marginTop: '-1.5%' }}
							id="long-menu"
							anchorEl={anchorED}
							open={editDelete_pop_opens}
							onClose={handleClose}
							PaperProps={{
								style: {
									width: '83px',
									width: '72px',
									borderRadius: '7px',
									boxShadow: '0px 1px 10px 0px #00000040',
								},
							}}
						>
							<MenuItem onClick={() => handleEdit()} sx={{ fontSize: '14px' }}>
								Edit
							</MenuItem>
							<MenuItem
								onClick={() => handleDelete()}
								sx={{ fontSize: '14px', color: '#ED2828' }}
							>
								Delete
							</MenuItem>
						</Menu>
					</div>
					// <IconButton style={{ fontSize: '1.2rem' }}>
					// 	<Tooltip title="Edit User">
					// 		<BorderColorOutlinedIcon
					// 			fontSize="small"
					// 			style={{ marginLeft: 5, cursor: 'pointer', color: 'black' }}
					// 			onClick={() => handleEdit(params)}
					// 		/>
					// 	</Tooltip>
					// 	<Tooltip title="Delete User">
					// 		<DeleteOutlinedIcon
					// 			fontSize="small"
					// 			style={{ marginLeft: 5, cursor: 'pointer', color: 'black' }}
					// 			onClick={() => handleDelete(params)}
					// 		/>
					// 	</Tooltip>
					// </IconButton>
				);
			},
		},
	];
	// const handleClick = (event) => {
	// 	setAnchorEl(event.currentTarget);
	// };
	// const handleClose = () => {
	// 	setAnchorEl(null);
	// };

	// const [page, setPage] = React.useState(0);
	// const [rowsPerPage, setRowsPerPage] = React.useState(8);

	// const handleChangePage = (event, newPage) => {
	// 	setPage(newPage);
	// };

	// const handleChangeRowsPerPage = (event) => {
	// 	setRowsPerPage(+event.target.value);
	// 	setPage(0);
	// };

	return (
		<div>
			{loading ? (
				<BrandedLoader
					title="Loading payers"
					text="Preparing payer records"
					minHeight="45vh"
				/>
			) : (
				<Box
					sx={{
						width: '100%',
						background: '#fff',
						border: '1px solid #dce8f5',
						borderRadius: '8px',
						overflow: 'hidden',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: { xs: 'flex-start', sm: 'center' },
							gap: 2,
							flexDirection: { xs: 'column', sm: 'row' },
							p: 2,
							borderBottom: '1px solid #edf2f8',
						}}
					>
						<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
							<Box
								sx={{
									width: 48,
									height: 48,
									borderRadius: '8px',
									background: '#edf4ff',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									color: '#2563eb',
									flex: '0 0 auto',
								}}
							>
								<CreditCardOutlined sx={{ fontSize: 26 }} />
							</Box>
							<Box>
								<Typography
									sx={{
										color: '#0b1f42',
										fontFamily: 'Poppins',
										fontSize: '18px',
										fontWeight: 700,
										lineHeight: 1.2,
									}}
								>
									Payers
								</Typography>
								<Typography
									sx={{
										color: '#64748b',
										fontFamily: 'Poppins',
										fontSize: '13px',
										fontWeight: 500,
										mt: 0.4,
									}}
								>
									Manage all insurance payers and plans
								</Typography>
							</Box>
						</Box>
						<Button
							onClick={() => openAddPayerModal?.()}
							startIcon={<Add />}
							sx={{
								height: '42px',
								px: 2.4,
								borderRadius: '7px',
								backgroundColor: '#2f6edb',
								color: '#fff',
								fontFamily: 'Poppins',
								fontSize: '13px',
								fontWeight: 700,
								textTransform: 'none',
								boxShadow: '0 4px 10px rgba(47, 110, 219, 0.2)',
								'&:hover': {
									backgroundColor: '#245fc5',
								},
							}}
						>
							Add Payer
						</Button>
					</Box>

					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							gap: 2,
							flexWrap: 'wrap',
							p: 2,
						}}
					>
						<TextField
							size="small"
							value={searchText}
							onChange={(event) => setSearchText(event.target.value)}
							placeholder="Search payer by name or type..."
							sx={{
								width: { xs: '100%', sm: 360 },
								'& .MuiOutlinedInput-root': {
									height: '40px',
									borderRadius: '6px',
									fontFamily: 'Poppins',
									fontSize: '13px',
									color: '#0b2450',
									'& fieldset': { borderColor: '#d7e3f4' },
									'&:hover fieldset': { borderColor: '#b8c9df' },
									'&.Mui-focused fieldset': { borderColor: '#2f6edb' },
								},
							}}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<Search sx={{ color: '#526f9f', fontSize: 22 }} />
									</InputAdornment>
								),
							}}
						/>
						<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
							<Select
								size="small"
								value={typeFilter}
								displayEmpty
								onChange={(event) => setTypeFilter(event.target.value)}
								sx={{
									width: 200,
									height: '40px',
									borderRadius: '6px',
									fontFamily: 'Poppins',
									fontSize: '13px',
									color: '#0b2450',
									'& fieldset': { borderColor: '#d7e3f4' },
									'&:hover fieldset': { borderColor: '#b8c9df' },
									'&.Mui-focused fieldset': { borderColor: '#2f6edb' },
								}}
								MenuProps={{
									PaperProps: {
										sx: {
											mt: 0.5,
											borderRadius: '6px',
											boxShadow: '0 8px 24px rgba(15, 23, 42, 0.12)',
											'& .MuiMenuItem-root': {
												fontFamily: 'Poppins',
												fontSize: '13px',
											},
										},
									},
								}}
							>
								<MenuItem value="">All Types</MenuItem>
								{payerTypes.map((type) => (
									<MenuItem key={type} value={type}>
										{type}
									</MenuItem>
								))}
							</Select>
						</Box>
					</Box>

					<Box
						sx={{
							px: 2,
							pb: 2,
							height: 'calc(100vh - 320px)',
							maxHeight: '760px',
							minHeight: '420px',
							overflow: 'hidden',
						}}>
						<DataGrid
							rows={filteredRows}
							rowHeight={42}
							columnHeaderHeight={42}
							columns={columns}
							fontFamily={'Poppins'}
							initialState={{
								pagination: { paginationModel: { pageSize: 10 } },
							}}
							pageSizeOptions={[10, 25, 50]}
							// checkboxSelection
							disableRowSelectionOnClick
							sx={{
								height: '100%',
								border: '1px solid #dce8f5',
								borderRadius: '6px',
								'& .MuiDataGrid-virtualScroller': {
									overflowY: 'auto',
								},
								color: '#0b2450',
								fontFamily: 'Poppins',
								'& .MuiDataGrid-columnHeaders': {
									background: '#f3f7fc',
									color: '#233b63',
									fontFamily: 'Poppins',
									fontWeight: 700,
									fontSize: '13px',
									borderBottom: '1px solid #dce8f5',
								},
								'& .MuiDataGrid-columnHeaderTitle': {
									fontWeight: 700,
								},
								'& .MuiDataGrid-cell': {
									borderBottom: '1px solid #edf2f8',
									outline: 'none !important',
								},
								'& .MuiDataGrid-row:hover': {
									backgroundColor: '#f8fbff',
								},
								'& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus':
								{
									outline: 'none',
								},
								'& .MuiDataGrid-footerContainer': {
									justifyContent: 'flex-end',
									backgroundColor: '#fff',
									borderTop: '1px solid #edf2f8',
									minHeight: '58px',
									px: 1,
								},
								'& .MuiTablePagination-root': {
									color: '#0b2450',
									fontFamily: 'Poppins',
								},
								'& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows':
								{
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 600,
								},
								'& .MuiTablePagination-select': {
									fontFamily: 'Poppins',
									fontSize: '13px',
								},
								'& .MuiTablePagination-actions button': {
									border: '1px solid #d7e3f4',
									width: '34px',
									height: '34px',
									mx: 0.4,
								},
							}}
						/>
					</Box>

					{/* Modal Structure */}
					<Modal
						open={openModal}
						// onClose={handleCloseModal} // Close Modal When any screen click.
						aria-labelledby="edit-modal-title"
						aria-describedby="edit-modal-description"
						sx={{
							'& .MuiModal-backdrop': {
								opacity: '0.75 !important',
							},
						}}
					>
						<Box sx={style}>
							<Box
								sx={{
									height: '60px',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'space-between',
									px: 2,
									borderBottom: '1px solid #edf2f8',
								}}
							>
								<Typography
									sx={{
										fontFamily: 'Poppins',
										fontSize: '20px',
										fontWeight: 700,
										color: '#111827',
									}}
								>
									Edit Payer
								</Typography>
								<IconButton
									onClick={handleCloseModal}
									sx={{ color: '#475569' }}
								>
									<CancelIcon sx={{ fontSize: '22px' }} />
								</IconButton>
							</Box>
							<Grid container spacing={2.2} sx={{ p: 2.4 }}>
								<Grid item lg={4} md={4} sm={12} xs={12}>
									<InputLabel sx={modalLabelSx}>
										Payer Name <span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="Name"
										size="small"
										fullWidth
										value={modalValues?.Name || ''}
										onChange={handleInputChange}
										placeholder="Enter payer name"
										sx={modalFieldSx}
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<PersonOutline
														sx={{ color: '#7b8ba5', fontSize: 20 }}
													/>
												</InputAdornment>
											),
										}}
									/>
									{errors.Name && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Name}
										</div>
									)}
								</Grid>
								<Grid item lg={4} md={4} sm={12} xs={12}>
									<InputLabel sx={modalLabelSx}>
										Payer Type <span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<Select
										name="Type"
										size="small"
										fullWidth
										displayEmpty
										value={modalValues?.Type || ''}
										onChange={targetModalValue}
										sx={modalFieldSx}
										MenuProps={modalSelectMenuProps}
										renderValue={(selected) =>
											selected || (
												<span style={{ color: '#8b9ab0' }}>
													Select payer type
												</span>
											)
										}
									>
										<MenuItem value={'private'}>Private</MenuItem>
										<MenuItem value={'government'}>Government</MenuItem>
									</Select>
								</Grid>
								<Grid item lg={4} md={4} sm={12} xs={12}>
									<InputLabel sx={modalLabelSx}>Contact</InputLabel>
									<Box sx={{ position: 'relative' }}>
										<MaskedInput
											required
											name="Contact"
											value={modalValues?.Contact || ''}
											onChange={handleInputChange}
											placeholder="Enter contact name"
											mask={[
												'(',
												/\d/,
												/\d/,
												/\d/,
												')',
												' ',
												/\d/,
												/\d/,
												/\d/,
												'-',
												/\d/,
												/\d/,
												/\d/,
												/\d/,
											]}
											style={modalMaskedInputStyle}
										/>
										<Call
											sx={{
												color: '#7b8ba5',
												fontSize: 20,
												position: 'absolute',
												right: 12,
												top: 11,
											}}
										/>
									</Box>
									{errors.Contact && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Contact}
										</div>
									)}
								</Grid>
								<Grid item xs={12}>
									<InputLabel sx={modalLabelSx}>
										Address <span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="Address"
										size="small"
										fullWidth
										value={modalValues?.Address || ''}
										onChange={targetModalValue}
										placeholder="Enter street address"
										sx={modalFieldSx}
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<PlaceOutlined
														sx={{ color: '#7b8ba5', fontSize: 20 }}
													/>
												</InputAdornment>
											),
										}}
									/>
								</Grid>
								<Grid item lg={4} md={4} sm={12} xs={12}>
									<InputLabel sx={modalLabelSx}>
										City <span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="City"
										size="small"
										fullWidth
										value={modalValues?.City || ''}
										onChange={handleInputChange}
										placeholder="Enter city"
										sx={modalFieldSx}
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<BusinessOutlined
														sx={{ color: '#7b8ba5', fontSize: 20 }}
													/>
												</InputAdornment>
											),
										}}
									/>
									{errors.City && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.City}
										</div>
									)}
								</Grid>
								<Grid item lg={4} md={4} sm={12} xs={12}>
									<InputLabel sx={modalLabelSx}>
										State <span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="State"
										size="small"
										fullWidth
										value={modalValues?.State || ''}
										onChange={handleInputChange}
										placeholder="Select state"
										sx={modalFieldSx}
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<ApartmentOutlined
														sx={{ color: '#7b8ba5', fontSize: 20 }}
													/>
												</InputAdornment>
											),
										}}
									/>
									{errors.State && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.State}
										</div>
									)}
								</Grid>
								<Grid item lg={4} md={4} sm={12} xs={12}>
									<InputLabel sx={modalLabelSx}>
										ZIP <span style={{ color: '#d61b1b' }}>*</span>
									</InputLabel>
									<TextField
										name="Zip"
										size="small"
										fullWidth
										value={modalValues?.Zip || ''}
										onChange={handleInputChange}
										placeholder="Enter ZIP code"
										sx={modalFieldSx}
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<Inventory2Outlined
														sx={{ color: '#7b8ba5', fontSize: 20 }}
													/>
												</InputAdornment>
											),
										}}
									/>
									{errors.Zip && (
										<div style={{ color: 'red', fontSize: '10px' }}>
											{errors.Zip}
										</div>
									)}
								</Grid>
								<Grid item xs={12}>
									<InputLabel sx={modalLabelSx}>Comments</InputLabel>
									<TextField
										name="Comments"
										multiline
										rows={3}
										fullWidth
										value={modalValues?.Comments || ''}
										onChange={(event) =>
											setModalValues((prev) => ({
												...prev,
												Comments: event.target.value.slice(0, 500),
											}))
										}
										placeholder="Enter any additional comments (optional)"
										sx={modalMultilineFieldSx}
										InputProps={{
											endAdornment: (
												<InputAdornment
													position="end"
													sx={{ alignSelf: 'flex-end', pb: 1 }}
												>
													<FormatListBulletedOutlined
														sx={{ color: '#7b8ba5', fontSize: 20 }}
													/>
												</InputAdornment>
											),
										}}
									/>
									<Typography
										sx={{
											color: '#7b8ba5',
											fontFamily: 'Poppins',
											fontSize: '12px',
											mt: 0.6,
										}}
									>
										{modalValues?.Comments?.length || 0} / 500 characters
									</Typography>
								</Grid>
							</Grid>
							<Box
								sx={{
									display: 'flex',
									justifyContent: 'flex-end',
									gap: 1.5,
									p: 2,
									borderTop: '1px solid #edf2f8',
								}}
							>
								<Button
									onClick={handleCloseModal}
									sx={{
										height: '40px',
										minWidth: 126,
										borderRadius: '6px',
										border: '1px solid #cfd8e6',
										color: '#2f4467',
										fontFamily: 'Poppins',
										fontSize: '13px',
										fontWeight: 700,
										textTransform: 'none',
									}}
								>
									Cancel
								</Button>
								<Button
									disabled={
										errors?.Name
										// || errors?.City
										//|| errors?.Contact ||
										// errors?.State ||
										// errors?.Zip
									}
									startIcon={<Add />}
									sx={{
										height: '40px',
										minWidth: 142,
										borderRadius: '6px',
										backgroundColor: errors?.Name ? '#cbd5e1' : '#2f6edb',
										color: '#fff',
										fontFamily: 'Poppins',
										fontSize: '13px',
										fontWeight: 700,
										textTransform: 'none',
										boxShadow: errors?.Name
											? 'none'
											: '0 4px 10px rgba(47, 110, 219, 0.2)',
										'&:hover': {
											backgroundColor: errors?.Name ? '#cbd5e1' : '#245fc5',
										},
									}}
									onClick={() => updateModalValues(modalValues)}
								>
									Update Payer
								</Button>
							</Box>
						</Box>
					</Modal>

					{/*Delete Dialog Structure */}

					<Dialog
						// fullScreen={fullScreen}
						open={deletePopupOpen}
						onClose={handleDialogClose}
						aria-labelledby="responsive-dialog-title"
						PaperProps={{
							sx: {
								width: 'min(410px, calc(100vw - 32px))',
								borderRadius: '8px',
								boxShadow: '0 18px 45px rgba(15, 23, 42, 0.24)',
								m: 0,
								overflow: 'hidden',
							},
						}}
					>
						<DialogTitle
							id="responsive-dialog-title"
							sx={{
								width: '100%',
								display: 'flex',
								justifyContent: 'flex-end',
								alignItems: 'center',
								p: '14px 14px 0',
							}}
						>
							<IconButton
								sx={{ width: 32, height: 32, color: '#64748b' }}
								size="small"
								onClick={deleteCancelPopup}
							>
								<CloseIcon sx={{ fontSize: '20px' }} />
							</IconButton>
						</DialogTitle>
						<DialogContent sx={{ p: 0, overflow: 'visible' }}>
							<Box sx={{ px: 3, pt: 1.2, pb: 3 }}>
								<Box
									sx={{
										width: 64,
										height: 64,
										borderRadius: '50%',
										background: '#fff1f2',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										mx: 'auto',
										mb: 2.2,
										boxShadow: '0 0 0 8px #fff7f8',
									}}
								>
									<DeleteOutlinedIcon sx={{ color: '#ef4444', fontSize: 30 }} />
								</Box>
								<Typography
									textAlign="center"
									sx={{
										fontFamily: 'Poppins',
										fontWeight: 500,
										fontSize: '15px',
										color: '#1f2937',
										mb: 1,
									}}
								>
									Are you sure you want to delete this payer?
								</Typography>
								<Typography
									textAlign="center"
									sx={{
										fontFamily: 'Poppins',
										fontWeight: 700,
										fontSize: '14px',
										color: '#005cff',
										textTransform: 'uppercase',
										wordBreak: 'break-word',
										lineHeight: 1.5,
									}}
								>
									{deleteUser}
								</Typography>
							</Box>
						</DialogContent>
						<Box
							sx={{
								display: 'grid',
								gridTemplateColumns: '1fr 1fr',
								gap: 1.5,
								px: 3,
								py: 2.5,
								borderTop: '1px solid #edf2f8',
							}}
						>
							<Button
								onClick={deleteCancelPopup}
								startIcon={<CloseIcon sx={{ fontSize: '18px !important' }} />}
								sx={{
									height: 42,
									borderRadius: '6px',
									border: '1px solid #d7e3f4',
									color: '#ef4444',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
									'&:hover': {
										background: '#fff5f5',
										borderColor: '#fecaca',
									},
								}}
							>
								No
							</Button>
							<Button
								onClick={() => {
									deletePayer(deleteID, deleteStatus);
								}}
								startIcon={
									<CheckCircleOutlineIcon
										sx={{ fontSize: '18px !important' }}
									/>
								}
								sx={{
									height: 42,
									borderRadius: '6px',
									backgroundColor: '#2f6edb',
									color: '#fff',
									fontFamily: 'Poppins',
									fontSize: '13px',
									fontWeight: 700,
									textTransform: 'none',
									boxShadow: '0 4px 10px rgba(47, 110, 219, 0.2)',
									'&:hover': {
										backgroundColor: '#245fc5',
									},
								}}
							>
								Yes
							</Button>
						</Box>
					</Dialog>

					{/* Show Snackbar After Deletion */}

					<Snackbar
						open={openSnackbar}
						onClose={handleCloseSnackbar}
						autoHideDuration={1500}
						anchorOrigin={{
							vertical: 'center',
							horizontal: 'center',
						}}
					>
						<Alert
							onClose={handleCloseSnackbar}
							// severity="error"
							severity="success"
							variant="filled"
							sx={{
								width: '100%',
								textAlign: 'center',
								fontSize: '13px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
							}}
							action={
								<React.Fragment>
									<span
										onClick={() => {
											handleCloseSnackbar();
										}}
										style={{
											cursor: 'pointer',
											m: 'auto 0',
											fontSize: '13px',
											color: 'rgb(231, 231, 231)',
										}}
									>
										Close
									</span>
								</React.Fragment>
							}
						>
							{severity === 'success'
								? 'Payer Deleted Successfully !'
								: 'Payer Updated Successfully !'}
						</Alert>
					</Snackbar>
				</Box>
			)}
		</div>
	);
}

Viewpayer.propTypes = {
	renderHandleFromChild: PropTypes.func,
	openAddPayerModal: PropTypes.func,
};

export default Viewpayer;
